/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Step_1Inputs */

const da_forside_example_step_1 = /** @type {(inputs: Forside_Example_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hent filerne her på siden. Det kræver ingen konto.`)
};

/** @type {(inputs: Forside_Example_Step_1Inputs) => LocalizedString} */
const en_forside_example_step_1 = da_forside_example_step_1;

/**

* @param {Forside_Example_Step_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_step_1 = /** @type {((inputs?: Forside_Example_Step_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Step_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_step_1(inputs)
	return /** @type {LocalizedString} */ ("Hent filerne her på siden. Det kræver ingen konto.")
});